import React from 'react';
import PropTypes from 'prop-types';
import { NavigationRowText, NavigationRowWrapper } from './styled/NavigationRowWrapper';

const NavigationRow = ({ capitalize, backRow, handleClick, text, red, children }) => (
  <NavigationRowWrapper
    data-cy={`nav-link-${text.toLowerCase()}`}
    capitalize={capitalize}
    red={red}
    onClick={handleClick}
    backRow={backRow}
  >
    <NavigationRowText>{text}</NavigationRowText>
    {children}
  </NavigationRowWrapper>
);

NavigationRow.propTypes = {
  backRow: PropTypes.bool,
  capitalize: PropTypes.bool,
  handleClick: PropTypes.func,
  text: PropTypes.string,
  red: PropTypes.bool,
};

export default NavigationRow;
